import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { DzCardModule } from '@blk/daisy/modules/cards';
import { AnalyticsModule } from '@ddt-web/analytics';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { GenericPipesModule } from '@ddt-web/generic-utils';

import { PortfolioSelectionCardsContainerComponent } from './portfolio-selection-cards-container';
import { PortfolioSelectionCardComponent } from './portfolio-selection-cards-container/grey-selection-card';

@NgModule({
	declarations: [PortfolioSelectionCardsContainerComponent, PortfolioSelectionCardComponent],
	imports: [CommonModule, CwpNgFrameworkModule, DzCardModule, DzCheckboxModule, GenericPipesModule, DataServiceModule, DisclosureModule, AnalyticsModule, RouterModule],
	exports: [PortfolioSelectionCardsContainerComponent, PortfolioSelectionCardComponent]
})
export class PortfolioSelectionCardsModule { }
